module.exports = __webpack_public_path__ + "img/icon-video-chat.18e0a8b9.svg";